import {Step, Stepper, Typography} from "@material-tailwind/react";
import {BuildingLibraryIcon, IdentificationIcon, InboxArrowDownIcon, UserIcon} from "@heroicons/react/24/outline";


export function BackOfficeAgentRequestSteps({
                                              activeStep, setActiveStep, isLastStep, setIsLastStep, isFirstStep,
                                              setIsFirstStep, handleNext, handlePrev, allowedStep
                                            }) {

  return (
    <div className="w-full py-4" style={{direction: "ltr"}}>
      <Stepper
        className="flex flex-row justify-between px-4"
        activeStep={activeStep}
        isLastStep={(value) => setIsLastStep(value)}
        isFirstStep={(value) => setIsFirstStep(value)}
      >
        <Step onClick={() => setActiveStep(0)}>
          <UserIcon className="h-5 w-5"/>
          <div className="absolute -bottom-[4.5rem] w-max text-center">
            <Typography
              className="text-xs md:text-sm"
              color={activeStep === 0 ? "blue-gray" : "gray"}
            >
              گام‌اول
            </Typography>
            <Typography
              color={activeStep === 0 ? "blue-gray" : "gray"}
              className="text-xs md:text-sm"
            >
              اطلاعات‌هویتی
            </Typography>
          </div>
        </Step>
        <Step onClick={() => {
          if (allowedStep >= 1) {
            setActiveStep(1);
          }
        }
        }
        >
          <BuildingLibraryIcon className="h-5 w-5"/>
          <div className="absolute -bottom-[4.5rem] w-max text-center">
            <Typography
              className="text-xs md:text-sm"
              color={activeStep === 1 ? "blue-gray" : "gray"}
            >
              گام‌دوم
            </Typography>
            <Typography
              color={activeStep === 1 ? "blue-gray" : "gray"}
              className="text-xs md:text-sm"
            >
              اطلاعات‌ارتباطی
            </Typography>
          </div>
        </Step>
        <Step onClick={() => {
          if (allowedStep >= 2) {
            setActiveStep(2);
          }
        }
        }
        >
          <IdentificationIcon className="h-5 w-5"/>
          <div className="absolute -bottom-[4.5rem] w-max text-center">
            <Typography
              className="text-xs md:text-sm"
              color={activeStep === 2 ? "blue-gray" : "gray"}
            >
              گام‌سوم
            </Typography>
            <Typography
              color={activeStep === 2 ? "blue-gray" : "gray"}
              className="text-xs md:text-sm"
            >
              رشته‌تخصصی
            </Typography>
          </div>
        </Step>
        <Step
          onClick={() => {
            if (allowedStep >= 3) {
              setActiveStep(3);
            }
          }
          }
        >
          <InboxArrowDownIcon className="h-5 w-5"/>
          <div className="absolute -bottom-[4.5rem] w-max text-center">
            <Typography
              className="text-xs md:text-sm"
              color={activeStep === 3 ? "blue-gray" : "gray"}
            >
              گام‌چهارم
            </Typography>
            <Typography
              color={activeStep === 3 ? "blue-gray" : "gray"}
              className="text-xs md:text-sm"
            >
              بارگزاری‌مدارک
            </Typography>
          </div>
        </Step>
      </Stepper>
    </div>
  );
}